module.exports = __webpack_public_path__ + "img/widgettrust-1.b748c85f.png";